import { Table } from '@tanstack/react-table';
import debounce from 'just-debounce-it';
import { useCallback } from 'react';

import { InputSearch } from '../../../patterns/input/input-search';
import { DataTableVisibilityOption } from '../data-table-visibility-option';
import { DEBOUNCE_TIME } from './debounce.constants';

interface DataTableToolbarProps<TData> {
  disabled?: boolean;
  filtering?: {
    placeholder?: string;
    queryParam?: string;
  };
  id?: string;
  table: Table<TData>;
}

export function DataTableToolbar<TData>({
  disabled = false,
  filtering,
  id,
  table,
}: DataTableToolbarProps<TData>) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceApplyFilter = useCallback(
    debounce((inputValue: string) => {
      // Ref: https://tanstack.com/table/v8/docs/guide/global-filtering
      table.setGlobalFilter(inputValue);
    }, DEBOUNCE_TIME),
    [],
  );

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex-auto">
        <InputSearch
          id={id ? `${id}-filteringInput` : undefined}
          className="max-w-96"
          disabled={disabled}
          queryParam={filtering?.queryParam}
          placeholder={filtering?.placeholder ?? 'Buscar'}
          onValueChange={debounceApplyFilter}
        />
      </div>
      <div className="flex-none">
        <DataTableVisibilityOption id={id} disabled={disabled} table={table} />
      </div>
    </div>
  );
}
